import { gql } from "apollo-boost";

// 담당으로 지정된 충전내역 설정 목록
export const CHARGEMANAGER_CONFIG_LIST_QUERY = gql`
  query ChargeManagerChargeRequestConfigList {
    ChargeManagerChargeRequestConfigList {
      id
      name
      createdAt
    }
  }
`;

// 담당 범위로 한정된 충전내역
export const CHARGEMANAGER_CHARGEREQUEST_LIST_QUERY = gql`
  query ChargeManagerChargeRequestList(
    $chargeRequestConfig: String
    $commonStatus: String
    $pay_method: String
    $startSearchDate: String
    $endSearchDate: String
    $keyword: String
    $orderBy: String
    $skip: Int
    $first: Int
  ) {
    ChargeManagerChargeRequestList(
      chargeRequestConfig: $chargeRequestConfig
      commonStatus: $commonStatus
      pay_method: $pay_method
      startSearchDate: $startSearchDate
      endSearchDate: $endSearchDate
      keyword: $keyword
      orderBy: $orderBy
      skip: $skip
      first: $first
    ) {
      chargeRequests {
        id
        commonStatus
        currency
        pay_method
        merchant_uid
        name
        amount
        buyer_name
        buyer_tel
        buyer_email
        vbank_name
        vbank_num
        vbank_date
        createdAt
        user {
          id
          userId
          name
        }
      }
      count
    }
  }
`;

export const CHARGEMANAGER_APPROVAL_QUERY = gql`
  mutation ChargeManagerChargeRequestApproval($id: String!) {
    ChargeManagerChargeRequestApproval(id: $id)
  }
`;

export const CHARGEMANAGER_CANCEL_QUERY = gql`
  mutation ChargeManagerChargeRequestCancel($id: String!) {
    ChargeManagerChargeRequestCancel(id: $id)
  }
`;
